module.exports = __webpack_public_path__ + "img/PositiveMediaWideBlue.42833333.png";